import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { CommandService } from '@core/services/command.service';
import { GraphQLService } from '@core/services/graphql.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GraphqlContentScope } from '@shared/models/graphql-content-scope.model';
import { DoNothingAction } from '@shared/store/actions/particle.actions';
import { of } from 'rxjs';
import {catchError, map, mergeMap, tap, withLatestFrom} from 'rxjs/operators';
import { CreateConversationAction } from '../collaboration/store/collaboration.action';
import { TaskManagerConfig } from '../helpers/task-manager.config';
import { TaskManagerQuery } from '../helpers/task-manager.query';
import { TaskManagerApiService } from '../services/task-manager-api.service';
import { TaskManagerService } from '../services/task-manager.service';
import {
  AddAttachmentAction,
  AddAttachmentFailedAction,
  AddSupportTaskAction,
  AddSupportTaskSuccessAction,
  AddTaskAction,
  AddTaskFailedAction,
  AddTaskSuccessAction, ADD_ATTACHMENT,
  ADD_COLUMN_NOTIFICATION,
  ADD_SUPPORT_TASK,
  ADD_TASK,
  ADD_TASK_SUCCESS,











  ChangeBoardColumnOrderAction,
  ChangeBoardColumnOrderSuccessAction,
  ChangeTaskOrderAction,
  ChangeTaskOrderSuccessAction, CHANGE_BOARD_COLUMN_ORDER,
  CHANGE_BOARD_COLUMN_ORDER_NOTIFICATION,
  CHANGE_TASK_ORDER,
  CHANGE_TICKET_STATUS_NOTIFICATION,





  CreateTicketNotificationAction, CREATE_TICKET_NOTIFICATION,

  CRETAE_BOARD_NOTIFICATION,




  DeleteTicketAction,
  DeleteTicketFailedAction,
  DeleteTicketSuccessAction, DELETE_BOARD_NOTIFICATION,
  DELETE_COLUMN_NOTIFICATION,
  DELETE_TICKET,
  DELETE_TICKET_NOTIFICATION,







  GetAllBoardsAction,
  GetAllBoardsFailedAction,
  GetAllBoardsSuccessAction,
  GetCompanyInfoAction,
  GetCompanyInfoFailedAction,
  GetCompanyInfoSuccessAction,
  GetSelectedBoardAction,
  GetSelectedBoardFailedAction,
  GetSelectedBoardSuccessAction,
  GetSelectedTaskAction,
  GetSelectedTaskFailedAction,
  GetSelectedTaskSuccessAction, GET_ALL_BOARD,
  GET_COMPANY_INFO,
  GET_SELECTED_BOARD,
  GET_SELECTED_TASK,













  UpdateStatusAction,
  UpdateStatusSuccessAction, UPDATE_STATUS
} from './task-manager.action';
import { TaskManagerHelper } from './task-manager.helper';
import { TaskManagerState } from './task-manager.reducer';
import { getselectedBoard } from './task-manager.selector';

@Injectable()
export class TaskManagerEffect {
  getAllBoards$ = createEffect(() => this.actions$
    .pipe(
      ofType(GET_ALL_BOARD),
      mergeMap((action: GetAllBoardsAction) => {
        return this.graphQLService.executePostRequest(action.apiKey, action.query)
          .pipe(
            map((payload: any) =>
              new GetAllBoardsSuccessAction(payload.data)
            ),
            catchError(error => of(new GetAllBoardsFailedAction(error)))
          );
      })
    ));
  addTaskSuccess$ = createEffect(() => this.actions$
    .pipe(
      ofType(ADD_TASK_SUCCESS),
      map((action: AddTaskSuccessAction) => {
        if (!action.payload.isOldTask && !action.payload.preventTaskAutoOpenAfterAdd) {
          this.taskManagerService.openTaskByTaskId(action.payload.Id ?? action.payload.id, GraphqlContentScope.getScope(action.payload.Scope ?? action.payload.scope));
        }
        return new DoNothingAction();
      })
    ));
  addTask$ = createEffect(() => this.actions$
    .pipe(
      ofType(ADD_TASK),
      mergeMap((action: AddTaskAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executePlatformCommand(action.command)
          .pipe(
            mergeMap(data => {
              this.fuseSplashScreenService.hide();
              if (action.invalidateSubjectRef) {
                action.invalidateSubjectRef.invalidate();
              }
              const ticket = data.fieldValues['Ticket'];
              ticket.isOldTask = action.isOldTask;
              ticket.preventTaskAutoOpenAfterAdd = action.preventTaskAutoOpenAfterAdd;
              return [new AddTaskSuccessAction(ticket), new GetSelectedBoardAction(action.apiKey,
                TaskManagerQuery.getSelectedBoard(ticket.boardId, action.scope))];
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              return of(new AddTaskFailedAction(error));
            })
          );
      })
    ));
  addSupportTask$ = createEffect(() => this.actions$
    .pipe(
      ofType(ADD_SUPPORT_TASK),
      mergeMap((action: AddSupportTaskAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            mergeMap(data => {
              this.fuseSplashScreenService.hide();
              if (action.createConversation) {
                const command = TaskManagerHelper.CreateSupportConversationCommand(data.Payload);
                return [new CreateConversationAction(command, ''),
                  new AddSupportTaskSuccessAction(data.Payload)];
              } else {
                return [new AddSupportTaskSuccessAction(data.Payload)];
              }
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              return of(new AddTaskFailedAction(error));
            })
          );
      })
    ));
  addAttachment$ = createEffect(() => this.actions$
    .pipe(
      ofType(ADD_ATTACHMENT),
      mergeMap((action: AddAttachmentAction) => {
        this.fuseSplashScreenService.show();
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(data => {
              this.fuseSplashScreenService.hide();
              // return new GetSelectedBoardAction(action.apiKey,
              //   TaskManagerQuery.getSelectedBoard(action.command.boardId, action.scope));
              return new DoNothingAction();
            }),
            catchError(error => {
              this.fuseSplashScreenService.hide();
              return of(new AddAttachmentFailedAction(error));
            })
          );
      })
    ));
  UpdateStatus$ = createEffect(() => this.actions$
    .pipe(
      ofType(UPDATE_STATUS),
      mergeMap((action: UpdateStatusAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(data => {
              // return new GetSelectedBoardAction(action.apiKey,
              //   TaskManagerQuery.getSelectedBoard(action.boardId, action.scope));
              return new UpdateStatusSuccessAction(data);
            }),
            catchError(error => of(new GetSelectedBoardAction(action.apiKey,
              TaskManagerQuery.getSelectedBoard(action.boardId, action.scope))))
          );
      })
    ));
  getSelectedBoard$ = createEffect(() => this.actions$
    .pipe(
      ofType(GET_SELECTED_BOARD),
      mergeMap((action: GetSelectedBoardAction) => {
        return this.graphQLService.executePostRequest(action.apiKey, action.query)
          .pipe(
            map((payload: any) =>
              new GetSelectedBoardSuccessAction(payload.data)
            ),
            catchError(error => of(new GetSelectedBoardFailedAction(error)))
          );
      })
    ));
/*  createTicketNotification$ = createEffect(() => this.actions$
    .pipe(
      ofType(CREATE_TICKET_NOTIFICATION),
      mergeMap((action: CreateTicketNotificationAction) => {
        return this.graphQLService.executePostRequest(TaskManagerConfig.TaskManagerApiKey,
          TaskManagerQuery.getSelectedBoard(action.payload.Payload.BoardId, GraphqlContentScope.getScope(action.payload.Payload.Scope)))
          .pipe(
            map((payload: any) => new GetSelectedBoardSuccessAction(payload.data)
            ),
            catchError(error => of(new GetSelectedBoardFailedAction(error)))
          );
      })
    ));*/
  deleteBoardNotification$ = createEffect(() => this.actions$
    .pipe(ofType(DELETE_BOARD_NOTIFICATION))
    .pipe(tap((it: any) => {
      this.taskManagerService.handleBoardsUpdate();
    }))
    .pipe(map(() => null)), {dispatch: false});

  createBoardNotification$ = createEffect(() => this.actions$
    .pipe(ofType(CRETAE_BOARD_NOTIFICATION))
    .pipe(tap((it: any) => {
      this.taskManagerService.handleBoardsUpdate();
    }))
    .pipe(map(() => null)), {dispatch: false});

  deleteTaskNotification$ = createEffect(() => this.actions$
    .pipe(ofType(DELETE_TICKET_NOTIFICATION))
    .pipe(withLatestFrom(this.taskManagerStore.select(getselectedBoard)))
    .pipe(tap((it: any) => {
      if (it[1] && it[0].payload.Payload) {
        this.getBoard(it, 'BoardId', GraphqlContentScope.getScope(it[0].payload.Payload.Scope));
      }
    }))
    .pipe(map(() => null)), {dispatch: false});

  changeTicketStatusNotification$ = createEffect(() => this.actions$
    .pipe(ofType(CHANGE_TICKET_STATUS_NOTIFICATION))
    .pipe(withLatestFrom(this.taskManagerStore.select(getselectedBoard)))
    .pipe(tap((it: any) => {
      if (it[1] && it[0].payload.Payload) {
        this.getBoard(it, 'BoardId', GraphqlContentScope.getScope(it[0].payload.Payload.Scope));
      }
    }))
    .pipe(map(() => null)), {dispatch: false});

  changeBoardColumnOrderNotification$ = createEffect(() => this.actions$
    .pipe(ofType(CHANGE_BOARD_COLUMN_ORDER_NOTIFICATION))
    .pipe(withLatestFrom(this.taskManagerStore.select(getselectedBoard)))
    .pipe(tap((it: any) => {
      if (it[1]) {
        this.getBoard(it, 'Id', it[1].scope);
      }
    }))
    .pipe(map(() => null)), {dispatch: false});

  addColumnNotification$ = createEffect(() => this.actions$
    .pipe(ofType(ADD_COLUMN_NOTIFICATION))
    .pipe(withLatestFrom(this.taskManagerStore.select(getselectedBoard)))
    .pipe(tap((it: any) => {
      if (it[1]) {
        this.getBoard(it, 'Id', it[1].scope);
      }
    }))
    .pipe(map(() => null)), {dispatch: false});
  deleteColumnNotification$ = createEffect(() => this.actions$
    .pipe(ofType(DELETE_COLUMN_NOTIFICATION))
    .pipe(withLatestFrom(this.taskManagerStore.select(getselectedBoard)))
    .pipe(tap((it: any) => {
      if (it[1]) {
        this.getBoard(it, 'Id', it[1].scope);
      }
    }))
    .pipe(map(() => null)), {dispatch: false});

  ChangeBoardColumnOrder$ = createEffect(() => this.actions$
    .pipe(
      ofType(CHANGE_BOARD_COLUMN_ORDER),
      mergeMap((action: ChangeBoardColumnOrderAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(data => {
              return new ChangeBoardColumnOrderSuccessAction(data);
            }),
            catchError(error => of(new GetSelectedBoardAction(action.apiKey,
              TaskManagerQuery.getSelectedBoard(action.boardId, action.scope))))
          );
      })
    ));

  ChangeTaskOrder$ = createEffect(() => this.actions$
    .pipe(
      ofType(CHANGE_TASK_ORDER),
      mergeMap((action: ChangeTaskOrderAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map(data => {
              return new ChangeTaskOrderSuccessAction(data);
            }),
            catchError(error => of(new GetSelectedBoardAction(action.apiKey,
              TaskManagerQuery.getSelectedBoard(action.boardId, action.scope))))
          );
      })
    ));
  getSelectedTask$ = createEffect(() => this.actions$
    .pipe(
      ofType(GET_SELECTED_TASK),
      mergeMap((action: GetSelectedTaskAction) => {
        return this.graphQLService.executePostRequest(action.apiKey, action.query)
          .pipe(
            map((payload: any) => {
                if (payload.data && !payload.data.ticketWithBoard) {
                  console.log('failedTask id from effect', payload);
                  this.snackBarService
                  .showError('Note: This task is no longer available. Either because the task was completed/deleted, or you are no longer required to provide action on this task.');
                  this.taskManagerStore.dispatch(new GetSelectedTaskFailedAction(payload, action.taskId));
                }
                return new GetSelectedTaskSuccessAction(payload.data);

              }
            ),

            catchError(error => of(new GetSelectedTaskFailedAction(error)))
          );
      })
    ));
  deleteTask$ = createEffect(() => this.actions$
    .pipe(
      ofType(DELETE_TICKET),
      mergeMap((action: DeleteTicketAction) => {
        return this.commandService.executeCommand(action.command)
          .pipe(
            map((notification: any) => {
              if (action.invalidateSubjectRef) {
                action.invalidateSubjectRef.invalidate();
              }
              return new DeleteTicketSuccessAction(notification.payload);
            }),
            catchError(error => of(new DeleteTicketFailedAction(error)))
          );
      })
    ));
  getCompanyInfo$ = createEffect(() => this.actions$
    .pipe(
      ofType(GET_COMPANY_INFO),
      mergeMap((action: GetCompanyInfoAction) => {
        return this.taskManagerApiService.getCompanyInfo(action.companyId)
          .pipe(
            map((companyInfo: any) => {
                return new GetCompanyInfoSuccessAction(companyInfo);
              }
            ),
            catchError(error => of(new GetCompanyInfoFailedAction(error)))
          );
      })
    ));

  constructor(private actions$: Actions,
              private commandService: CommandService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private graphQLService: GraphQLService,
              private snackBarService: SnackBarService,
              private taskManagerService: TaskManagerService,
              private taskManagerApiService: TaskManagerApiService,
              private taskManagerStore: Store<TaskManagerState>,
              protected route: Router,
              protected location: Location) {

  }

  private getBoard(it: any, prop, scope) {
    if (it[0].payload.Payload && it[0].payload.Payload[prop] === it[1].id) {
      this.taskManagerService.getSelectedBoard(it[0].payload.Payload[prop], scope);
    }
  }
}
